<template>
  <div class="carousel">
    <!-- Image Wrapper -->
    <div class="carousel-inner" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
      <div v-for="(image, index) in images" :key="index" class="carousel-item">
        <img :src="image" alt="Carousel image" />
      </div>
    </div>

    <!-- Navigation Controls -->
    <button class="carousel-control prev" @click="prevSlide">❮</button>
    <button class="carousel-control next" @click="nextSlide">❯</button>

    <!-- Indicators -->
    <div class="carousel-indicators">
      <span
        v-for="(image, index) in images"
        :key="index"
        class="indicator"
        :class="{ active: index === currentIndex }"
        @click="goToSlide(index)"
      ></span>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";

export default {
  name: "Carousel",
  props: {
    images: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const currentIndex = ref(0);

    // Go to the next slide
    const nextSlide = () => {
      currentIndex.value = (currentIndex.value + 1) % props.images.length;
    };

    // Go to the previous slide
    const prevSlide = () => {
      currentIndex.value = (currentIndex.value - 1 + props.images.length) % props.images.length;
    };

    // Jump to a specific slide
    const goToSlide = (index) => {
      currentIndex.value = index;
    };

    return { currentIndex, nextSlide, prevSlide, goToSlide };
  },
};
</script>

<style scoped>
.carousel {
  position: relative;
  width: 100%;
  max-width: 600px;
  overflow: hidden;
}

.carousel-inner {
  display: flex;
  transition: transform 0.5s ease;
}

.carousel-item {
  min-width: 100%;
}

.carousel img {
  width: 100%;
  height: auto;
}

.carousel-control {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0);
  color: #000;
  border: none;
  font-size: 24px;
  cursor: pointer;
  border-radius: 0.25rem;
  text-shadow: 1px 1px 2px #fff;
}

.carousel-control:hover {
  background: rgba(255, 255, 255, 0.5);
}

.carousel-control.prev {
  left: 10px;
}

.carousel-control.next {
  right: 10px;
}

.carousel-indicators {
  display: flex;
  justify-content: center;
  margin-top: -20px;
  position: relative;
  z-index: 1;

  .indicator {
    width: 10px;
    height: 10px;
    margin: 0 5px;
    background: #fff;
    border-radius: 50%;
    cursor: pointer;
    border: #666 1px solid;
  }
}

.indicator.active {
  background: var(--primary);
}
</style>
